import { render, staticRenderFns } from "./workloadRanking.vue?vue&type=template&id=053f7a42&scoped=true&"
import script from "./workloadRanking.vue?vue&type=script&lang=js&"
export * from "./workloadRanking.vue?vue&type=script&lang=js&"
import style0 from "./workloadRanking.vue?vue&type=style&index=0&id=053f7a42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f7a42",
  null
  
)

export default component.exports